<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div class="item-box-title">投资者第一次登录APP，可直接在妥妥递首页输入邀请码进行管理</div>
        <div class="item-box-slide">
          <cube-slide :showDots="false">
            <cube-slide-item>
              <img src="~@/assets/invite.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div class="item-box-slide-desc-n">
              <span>01</span>/01
            </div>
            <div class="item-box-slide-desc-text">输入邀请码</div>
          </div>
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">已有关联管理人时，点击右上角关联管理人，输入邀请码进行关联</div>
        <div class="item-box-slide">
          <cube-slide :initialIndex="slideIndex" :showDots="false" :autoPlay="false" @change="slideChange">
            <cube-slide-item>
              <img src="~@/assets/invite11.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/invite22.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideIndex + 1}`}}</span>/02
            </div>
            <div class="item-box-slide-desc-text">
              {{slideIndex === 0 ? '点击关联管理人' : '输入邀请码'}}
            </div>
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideIndex: 0,
    };
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
    $_jumpSlideItem(index) {
      this.slideIndex = index === 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  .item-box-title {
    font-size: 13px;
    color: #666666;
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
      }
    }
  }
}
</style>
